import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app-settings';
import {
  ICreateUserRequest,
  ICreateUserResponse,
  IDeleteUserResponse,
  IGetAllUserResponse,
  IGetMeResponse,
  IGetUserByIdResponse,
  IGetUsersPaginatedResponse,
  IUpdateMeRequest,
  IUpdateUserRequest,
  IUpdateUserResponse,
  IUploadFileResponse,
} from '../../interfaces/user.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  constructor(private http: HttpClient, private appSettings: AppSettings) {}

  getMe(): Observable<IGetMeResponse> {
    const url = this.appSettings.users.urls.getMe;
    return this.http.get<IGetMeResponse>(url);
  }

  patchProfile(data: IUpdateMeRequest): Observable<IGetMeResponse> {
    const url = this.appSettings.users.urls.patchProfile;
    return this.http.patch<IGetMeResponse>(url, data);
  }

  uploadFile(userId: number, file: File): Observable<IUploadFileResponse> {
    const url = this.appSettings.users.urls.uploadFile(userId);
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<IUploadFileResponse>(url, formData);
  }

  getUsers(page: number = 1, pageSize: number = 10, q?: string): Observable<IGetUsersPaginatedResponse> {
    let url = this.appSettings.users.urls.getUsers;
    url += `?page=${page}&pageSize=${pageSize}`;
    if (q) url += `&q=${encodeURIComponent(q)}`;
    return this.http.get<IGetUsersPaginatedResponse>(url);
  }

  getUserById(id: number): Observable<IGetUserByIdResponse> {
    const url = `${this.appSettings.users.urls.getUsers}/${id}`;
    return this.http.get<IGetUserByIdResponse>(url);
  }

  updateUser(id: number, data: IUpdateUserRequest): Observable<IUpdateUserResponse> {
    const url = `${this.appSettings.users.urls.patchUser}/${id}`;
    return this.http.patch<IUpdateUserResponse>(url, data);
  }

  deleteUser(id: number): Observable<IDeleteUserResponse> {
    const url = `${this.appSettings.users.urls.deleteUser}/${id}`;
    return this.http.delete<IDeleteUserResponse>(url);
  }

  createUser(data: ICreateUserRequest): Observable<ICreateUserResponse> {
    const url = `${this.appSettings.users.urls.createUser}`;
    return this.http.post<ICreateUserResponse>(url, data);
  }

  getDeletedUsers(): Observable<IGetAllUserResponse> {
    const url = `${this.appSettings.users.urls.getDeletedUsers}`;
    return this.http.get<IGetAllUserResponse>(url);
  }

  restoreDeletedUser(id: number): Observable<void> {
    const url = this.appSettings.users.urls.restoreDeletedUser(id);
    return this.http.patch<void>(url, {});
  }

}
